import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _omit from 'lodash/omit';
import PropTypes from 'prop-types';
// Models
import { isAllowed, getAllUserPermissions } from 'models/permission';
import { permissionsShape } from 'constants/PropTypesShapes';

const OnlyWith = ({
  alternativeComponent,
  carparkPermissions,
  children,
  devicePermissions,
  installationPermissions,
  isAdmin,
  meFeatures,
  permissions,
  userPermissions,
  ...otherProps
}) => {
  let allowed = true;

  // Permission is optionnal, so it can be null (in this case, the wrapped component is allowed)
  if (permissions) {
    allowed = isAllowed(permissions, {
      isAdmin,
      meFeatures,
      carparkPermissions,
      installationPermissions,
      devicePermissions,
      userPermissions,
    });
  }

  if (allowed) {
    const filteredOtherProps = _omit(otherProps, 'dispatch');
    return React.cloneElement(children, { ...filteredOtherProps });
  }

  return alternativeComponent;
};

OnlyWith.propTypes = {
  alternativeComponent: PropTypes.element,
  carparkPermissions: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.element.isRequired,
  devicePermissions: PropTypes.arrayOf(PropTypes.string),
  installationPermissions: PropTypes.arrayOf(PropTypes.string),
  isAdmin: PropTypes.bool,
  meFeatures: PropTypes.arrayOf(PropTypes.string),
  permissions: permissionsShape,
  userPermissions: PropTypes.arrayOf(PropTypes.string),
};

OnlyWith.defaultProps = {
  alternativeComponent: null,
  carparkPermissions: [],
  devicePermissions: [],
  installationPermissions: [],
  isAdmin: false,
  meFeatures: [],
  permissions: null,
  userPermissions: [],
};

const mapStateToProps = (state) => ({
  isAdmin: state.me.isAdmin,
  meFeatures: state.me.features,
  carparkPermissions: _get(state, 'cpmCarpark.current.data.permissions'), // Do not forget to reset this value by managing REINIT_AUTH action in corresponding reducer!
  installationPermissions: _get(state, 'installation.permissions'),
  devicePermissions: _get(state, 'device.permissions'),
  userPermissions: getAllUserPermissions(_get(state.me.data, 'permissions')),
});

module.exports = connect(mapStateToProps, null)(OnlyWith);



// WEBPACK FOOTER //
// ./components/permissions/OnlyWith.js